/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
'use strict';

var cart = require('../cart/cart');

function updateAriaLabel(message) {
    $('.minicart-link').each(function () {
        var base = $(this).data('base-label') || $(this).attr('aria-label');
        $(this).attr('aria-label', base + ', ' + message);
    });
}

module.exports.updateAriaLabel = updateAriaLabel;

module.exports = function () {
    cart();

    var miniCartInit = function () {
        $('#minicart-flyout').on('touchmove', function (e) {
            // console.log(e.target);
            e.stopPropagation();
        });
    };

    var $minicart = $('.minicart');

    $minicart.on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity, .minicart-tablet .minicart-quantity').text(count.quantityTotal);
            $('.minicart-mobile .minicart-quantity').text(count.quantityTotal);
            updateAriaLabel(count.cart.resources.numberOfItems);
        }

        if (count && count.mobileMiniCartHTML) {
            $('.minicart-container').html(count.mobileMiniCartHTML);
            miniCartInit();
        }
    });

    function closeMiniCart(returnFocusToTrigger) {
        $('.minicart .popover').empty();
        $('.minicart .popover').removeClass('show');
        $('.minicart-link').attr('aria-expanded', 'false');
        if (returnFocusToTrigger) {
            $('.minicart-link').first().trigger('focus');
        }
    }

    function showMiniCart(moveFocus) {
        if ($('.search:visible').length === 0) {
            return;
        }
        var url = $minicart.data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            $('.minicart .popover').addClass('show');
            $('.minicart-link').attr('aria-expanded', 'true');
            $('.minicart .popover').spinner().start();
            $.get(url, function (data) {
                $('.minicart .popover').empty();
                if ($(data).find('.product-summary .row').length > 0) {
                    // Returned data has product line items; display minicart
                    $('.minicart .popover').append(data);
                    $.spinner().stop();
                    if (moveFocus) {
                        trapFocus();
                    }
                } else {
                    // Session expired; minicart no longer valid so clean the desktop header and mobile nav menus
                    $('.minicart .popover').removeClass('show');
                    $('.minicart-link').attr('aria-expanded', 'false');
                    $.spinner().stop();

                    $('.minicart-link .minicart-quantity').text('0');

                    var $headerLoginArea = $('.header-login');
                    $headerLoginArea.find('.reward-points').removeClass('reward-points-loggedin');
                    $headerLoginArea
                        .find('.reward-points span')
                        .removeClass('reward-points-total')
                        .text('Reward Points');

                    var myAccountURL = $headerLoginArea.find('.user a').attr('href');
                    $headerLoginArea
                        .find('.user')
                        .empty()
                        .append(
                            '<a class="text-white" href="' +
                                myAccountURL +
                                '">' +
                                '<span class="user-message">Sign In</span>' +
                                '</a>'
                        );

                    var $mobileMenu = $('.nav-account-menu');
                    $mobileMenu
                        .find('.nav-item-user')
                        .empty()
                        .append(
                            '<a class="nav-link" href="' +
                                myAccountURL +
                                '">' +
                                '<span class="user-message">Sign In</span>' +
                                '</a>'
                        );
                    $mobileMenu
                        .find('.nav-item-rewards-loggedin')
                        .removeClass('nav-item-rewards-loggedin')
                        .addClass('nav-item-rewards-guest')
                        .find('span')
                        .removeClass('reward-points-total')
                        .text('Reward Points');
                    $mobileMenu.find('.nav-item-logout').remove();
                }
            });
        }
    }

    function trapFocus() {
        var focusableElements = 'button, [href], input, select, [tabindex]:not([tabindex="-1"])';
        // Scope to the popover only — the trigger button is outside this boundary
        var popover = document.querySelector('.minicart .popover');

        if (!popover) {
            return;
        }

        var focusableContent = popover.querySelectorAll(focusableElements);
        if (!focusableContent.length) {
            return;
        }

        var firstFocusableElement = focusableContent[0];
        var lastFocusableElement = focusableContent[focusableContent.length - 1];

        firstFocusableElement.focus();

        function handleKeydown(e) {
            if (e.key === 'Escape') {
                closeMiniCart(true);
                document.removeEventListener('keydown', handleKeydown);
                return;
            }

            if (e.key !== 'Tab') {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    // Shift+Tab at start of dialog: close and return focus to trigger button
                    e.preventDefault();
                    closeMiniCart(true);
                    document.removeEventListener('keydown', handleKeydown);
                }
            } else if (document.activeElement === lastFocusableElement) {
                // Tab past end of dialog: close and let focus continue naturally to next nav item
                closeMiniCart(false);
                document.removeEventListener('keydown', handleKeydown);
            }
        }

        document.addEventListener('keydown', handleKeydown);
    }

    $minicart.on('mouseenter touchstart', function () {
        showMiniCart(false);
    });

    // Toggle the dialog open/closed on explicit button activation (Enter, Space, or click)
    $('.minicart-link').on('click', function (e) {
        e.preventDefault();
        var miniCartQuantity = $('.minicart .minicart-quantity');
        if (miniCartQuantity.length && miniCartQuantity.text()) {
            var count = parseInt($('.minicart .minicart-quantity').text(), 10);
            if (!count) {
                window.location.href = $minicart.data('cart-url');
            } else if ($('.minicart .popover').hasClass('show')) {
                closeMiniCart(false);
            } else {
                showMiniCart(true);
            }
        }
    });

    $('body').on('touchstart click', function (e) {
        if ($minicart.has(e.target).length <= 0) {
            closeMiniCart(false);
        }
    });

    $(document).on('keyup', function (e) {
        if (e.keyCode == 27 && $('.minicart .popover').hasClass('show')) {
            closeMiniCart(false);
            $.spinner().stop();
        }
    });

    $minicart.on('mouseleave', function (event) {
        if (
            (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity')) ||
            $('body').hasClass('modal-open')
        ) {
            event.stopPropagation();
            return;
        }
        closeMiniCart(false);
    });

    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });

    $('.minicart-mobile, .minicart-tablet').on('click', function (e) {
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);
        if (!count) {
            e.preventDefault();
            window.location.href = $minicart.data('cart-url');
            return;
        }
        $('#minicart-flyout').show();
        e.stopPropagation();
        e.preventDefault();
        var headerFooterSpace =
            $('#minicart-flyout .minicart-footer').height() + $('#minicart-flyout .titlebar').height();
        var flyoutSize = $('#minicart-flyout .container.cart').height();
        $('body').addClass('no-scrollable');
        $('.product-summary').height(flyoutSize - headerFooterSpace);
        $('.remove-btn.remove-product span').text('Remove');
        // eslint-disable-next-line no-shadow
        $('#minicart-flyout .close-button').on('click', function (e) {
            e.preventDefault();
            $('body').removeClass('no-scrollable');
            $('#minicart-flyout').hide();
        });
    });

    miniCartInit();
};
